/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Recurrence_Interval_NoneInputs */

const en_enum_recurrence_interval_none = /** @type {(inputs: Enum_Recurrence_Interval_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interval None`)
};

const de_enum_recurrence_interval_none = /** @type {(inputs: Enum_Recurrence_Interval_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervall None`)
};

/**
* | output |
* | --- |
* | "Interval None" |
*
* @param {Enum_Recurrence_Interval_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_recurrence_interval_none = /** @type {((inputs?: Enum_Recurrence_Interval_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Recurrence_Interval_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_recurrence_interval_none(inputs)
	return de_enum_recurrence_interval_none(inputs)
});